import type {
  ClearTestUserOnboardingResult,
  TestUsersOnboardingResponse,
} from '@sparkapp/shared-types';
import { apiRequest } from './apiClient';

type Envelope<T> = { success: true; data: T };

export const testUsersApi = {
  async list(): Promise<TestUsersOnboardingResponse> {
    return (await apiRequest<Envelope<TestUsersOnboardingResponse>>('/v2/admin/test-users')).data;
  },

  async clearOnboarding(email: string): Promise<ClearTestUserOnboardingResult> {
    return (
      await apiRequest<Envelope<ClearTestUserOnboardingResult>>('/v2/admin/test-users/clear-onboarding', {
        method: 'POST',
        body: { email },
      })
    ).data;
  },
};
